// @module Tavano.FirstContentPage.FirstContentPage
define('Tavano.FirstContentPage.FirstContentPage.View'
,	[
		'tavano_firstcontentpage_firstcontentpage.tpl'
	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
		tavano_firstcontentpage_firstcontentpage_tpl
	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class Tavano.FirstContentPage.FirstContentPage.View @extends Backbone.View
	return Backbone.View.extend({

		template: tavano_firstcontentpage_firstcontentpage_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service 
				(you'll need to deploy and activate the extension first)
			*/
			this.message = '';
			// var service_url = Utils.getAbsoluteUrl(getExtensionAssetsPath('services/FirstContentPage.Service.ss'));

			// jQuery.get(service_url)
			// .then((result) => {

			// 	this.message = result;
			// 	this.render();
			// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
			
		}

		//@method getContext @return Tavano.FirstContentPage.FirstContentPage.View.Context
	,	getContext: function getContext()
		{
			//@class Tavano.FirstContentPage.FirstContentPage.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
